/**
 * Survey: PROJECT - FINAL IMPACT
 * Question: Have you opened any branches?
 * 
 * == final
 * branches_t1
 * 
 * @param props 
 * @returns 
 */
export const entrepreneursThatOpenedNewBranchesTotalCalculation = (props: any) => {
    const count = props.finalSubmissions.filter((submission: any) => submission.branches_t1 === 'Yes').length;

    return (count / props.finalSubmissions.length * 100).toFixed(2);
}